{
  "title": "Profil",
  "description": "Gérer vos informations de profil et paramètres",
  "tabs": {
    "personal": "Informations personnelles",
    "security": "Sécurité",
    "devices": "Appareils",
    "feedback": "Commentaires"
  },
  "personal": {
    "title": "Informations personnelles",
    "description": "Mettre à jour vos données personnelles",
    "success": "Informations personnelles mises à jour avec succès",
    "successDescription": "Vos informations personnelles ont été mises à jour avec succès",
    "error": "Erreur lors de la mise à jour des informations personnelles",
    "errorDescription": "Une erreur s'est produite lors de la mise à jour de vos informations personnelles.",
    "fields": {
      "avatar": "Photo de profil",
      "uploadAvatar": "Télécharger une photo",
      "avatarError": "Erreur de téléchargement d'image",
      "firstName": "Prénom",
      "lastName": "Nom",
      "email": "Email",
      "phone": "Téléphone",
      "gender": "Sexe",
      "genderOptions": {
        "man": "Homme",
        "woman": "Femme",
        "other": "Autre"
      },
      "language": "Langue",
      "languageOptions": {
        "en": "Anglais",
        "fr": "Français"
      },
      "theme": "Thème",
      "themeOptions": {
        "light": "Clair",
        "dark": "Sombre",
        "system": "Système"
      },
      "imageProcessError": "Échec du traitement du fichier image"
    },
    "saveChanges": "Sauvegarder les modifications",
    "updating": "Mise à jour...",
    "personalization": {
      "title": "Personnalisation",
      "description": "Personnaliser votre expérience"
    }
  },
  "security": {
    "title": "Paramètres de sécurité",
    "description": "Gérer la sécurité de votre compte",
    "changePassword": {
      "title": "Changer le mot de passe",
      "description": "Mettre à jour le mot de passe de votre compte pour une sécurité renforcée.",
      "fields": {
        "currentPassword": "Mot de passe actuel",
        "newPassword": "Nouveau mot de passe",
        "confirmPassword": "Confirmer le nouveau mot de passe"
      },
      "button": "Mettre à jour le mot de passe",
      "updating": "Mise à jour...",
      "success": "Mot de passe mis à jour avec succès",
      "successDescription": "Votre mot de passe a été mis à jour avec succès",
      "error": "Erreur lors de la mise à jour du mot de passe",
      "errorDescription": "Une erreur s'est produite lors de la mise à jour de votre mot de passe.",
      "errors": {
        "currentRequired": "Le mot de passe actuel est requis",
        "newRequired": "Le nouveau mot de passe est requis",
        "confirmRequired": "Veuillez confirmer votre nouveau mot de passe",
        "minLength": "Le mot de passe doit contenir au moins 6 caractères",
        "noMatch": "Les mots de passe ne correspondent pas",
        "samePassword": "Le nouveau mot de passe doit être différent du mot de passe actuel",
        "wrongCurrent": "Le mot de passe actuel est incorrect"
      }
    }
  },
  "feedback": {
    "mainTitle": "Envoyer des Commentaires",
    "description": "Aidez-nous à nous améliorer en partageant vos réflexions et suggestions",
    "title": {
      "label": "Titre",
      "placeholder": "Résumé bref de votre commentaire"
    },
    "type": {
      "label": "Type de Commentaire",
      "placeholder": "Sélectionner le type de commentaire",
      "options": {
        "bug": "Rapport de Bug",
        "feature": "Demande de Fonctionnalité",
        "contact": "Contact",
        "other": "Autre"
      }
    },
    "message": {
      "label": "Message",
      "placeholder": "Décrivez vos commentaires en détail..."
    },
    "anonymous": {
      "label": "Envoyer anonymement",
      "description": "Votre commentaire sera envoyé sans vos informations utilisateur"
    },
    "send": "Envoyer les Commentaires",
    "sending": "Envoi en cours...",
    "success": "Feedback envoyé avec succès !"
  },
  "errors": {
    "createProfileFailed": "Échec de la création du profil",
    "loadProfileFailed": "Échec du chargement du profil",
    "updateProfileFailed": "Échec de la mise à jour du profil"
  },
  "success": {
    "profileCreated": "Profil créé avec succès",
    "profileUpdated": "Profil mis à jour avec succès"
  }
}
